import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import form from './form.js'
import submit from './submit.js'

export default contract({
  form: array([
    form
  ]),
  submit: array([
    submit
  ])
})
